import React from 'react'

import { Button, Box, Modal, ModalInjectedProps } from '@sketch/components'
import { ShareInfoFragment } from '@sketch/gql-types'

export interface ChooseTargetDuplicationWorkspaceLayoutProps
  extends ModalInjectedProps {
  shareName: string
  shareType: ShareInfoFragment['shareType']
  isLoading: boolean
  isEnabled: boolean
  onActionClick?: () => void
  onDuplicationCancel: () => void
}

export const ChooseTargetDuplicationWorkspaceLayout: React.FCC<
  ChooseTargetDuplicationWorkspaceLayoutProps
> = props => {
  const {
    shareName,
    shareType,
    children,
    isLoading,
    isEnabled,
    onActionClick,
    onDuplicationCancel,
  } = props

  const getShareType = () => {
    switch (shareType) {
      case 'TEMPLATE':
        return 'Template'
      case 'LIBRARY':
        return 'Library'
      default:
        return 'Document'
    }
  }

  return (
    <Modal
      title={`Duplicate ${getShareType()} to My Drafts?`}
      onCancel={onDuplicationCancel}
    >
      <Modal.Body>
        Choose where you want to create a duplicate of “<b>{shareName}</b>”.
        <Box mt={6}>{children}</Box>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onDuplicationCancel}>Cancel</Button>
        <Button
          variant="primary"
          loading={isLoading}
          disabled={!isEnabled}
          onClick={onActionClick}
        >
          Duplicate
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
